/**
 * btn-toggle-content
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.btn-toggle-content',

	events: {
		click: 'onClickBtnToggleContent',
	},

	onClickBtnToggleContent() {
		if (window.innerWidth < 768) {
			const btn = this.el;
			btn.classList.toggle('btn-toggle-content-hidden');
			btn.classList.toggle('red-dark');

			const arrow = btn.querySelector('.arrow');
			arrow.classList.toggle('up');
			arrow.classList.toggle('white');
			arrow.classList.toggle('black');
		}
	},
});

export default View;

